<template>
    <div class="result-main">
        <van-row v-if="!paid"  type="flex" align="center" justify="center">
            <van-col>
                <van-loading type="spinner" size="14px"/>
            </van-col>
            <van-col class="result__loading-title"><span>订单支付中</span><span>...{{seconds}}s</span></van-col>
        </van-row>
        <van-row v-else type="flex" align="center" justify="center">
            <van-icon color="#ee0a24" name="checked" size="22"/>
            <van-col class="result__result-info">
                支付成功
            </van-col>
        </van-row>
        <van-row gutter="16" type="flex" justify="center" class="result__navigation_wrapper">
            <van-col>
                <van-button size="small" round type="default" @click="onGo(`/order/${orderNo}`)">查看订单</van-button>
            </van-col>
            <van-col>
                <van-button size="small" round type="default" @click="onGoHome">返回首页</van-button>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import {Col, Row, Icon, Button, Loading} from "vant";
import request from "@/utils/request.js";
import {navMixins} from "@/mixins.js";

export default {
    name: "Result",
    mixins: [navMixins],
    components: {
        [Col.name]: Col,
        [Row.name]: Row,
        [Icon.name]: Icon,
        [Button.name]: Button,
        [Loading.name]: Loading
    },
    data() {
        return {
            orderNo: undefined,
            paid: false,
            seconds: 5,
            timeInterval: undefined,
            reqInterval: undefined
        };
    },
    mounted() {
        this.orderNo = this.$route.params.order_no;
        var vm = this;
        const timeInterval = setInterval(function() {
            vm.seconds = vm.seconds - 1 > 0 ? vm.seconds - 1 : 0;
        }, 1000);
        const reqInterval = setInterval(async function() {
            const {data} = await request.post(`/customer/order/loadOrder?orderNo=${vm.orderNo}`, );
            if (data.orderState !== "TO_PAY") {
                clearInterval(reqInterval);
                clearInterval(timeInterval);
                // 【已付款】或者【待收货】状态（一般就这两个状态）
                if (data.orderState == "TO_SEND" ||
                    data.orderState == "TO_RECEIVE") {
                    vm.paid = true;
                }
            }
        }, 1000);
        this.timeInterval = timeInterval;
        this.reqInterval = reqInterval;
    },
    methods: {
        onGo(path) {
            // 替换路由
            if (this.timeInterval) {
                clearInterval(this.timeInterval);
            }
            if (this.reqInterval) {
                clearInterval(this.reqInterval);
            }
            this.$router.replace(path);
        },
    } 
}
</script>

<style lang="less">
@import "@/style/base.less";

.result-main {
    padding-top: 120px;
    min-height: 100vh;
    background-color: @color-background;

    .van-button {
        color: @font-color-secondary;
        background-color: #f2f3f5;
        border: 1px solid @color-border;
    }
}
.result__loading-title {
    padding-left: 8px;
    font-size: @font-size-title;
    color: @font-color-title;
}
.result__navigation_wrapper {
    margin-top: 32px;

    .van-button {
        height: 28px;
    }
}

.result__result-info {
    margin-left: 2px;
    color: @font-color-title;
    font-size: @font-size-title;
    font-weight: @font-weight-title;
    
}
</style>